import { render, staticRenderFns } from "./LiveStatistics.vue?vue&type=template&id=342cc3dd&scoped=true"
import script from "./LiveStatistics.vue?vue&type=script&lang=js"
export * from "./LiveStatistics.vue?vue&type=script&lang=js"
import style0 from "./LiveStatistics.vue?vue&type=style&index=0&id=342cc3dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342cc3dd",
  null
  
)

export default component.exports